import { render, staticRenderFns } from "./RefundProductPiecesList.vue?vue&type=template&id=aef4887e&"
import script from "./RefundProductPiecesList.vue?vue&type=script&lang=js&"
export * from "./RefundProductPiecesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports